import { useState } from 'react';
import moment from 'moment';
import { useCountup } from './index';

var useCountdown = function useCountdown(totalSeconds) {
  var secondsElapsed = useCountup();
  return totalSeconds - secondsElapsed;
};

export default useCountdown;